import { all, put, call, takeEvery, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { selectSizeBasedOnDeviceType } from 'yoda-site-components/lib/selectors/ContextSelector';
import { getSpecificationsByUrl } from 'yoda-interfaces/lib/Pdp/ProductSpecificationsApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import {
    PRODUCT_SPECIFICATIONS_GET_ERROR,
    PRODUCT_SPECIFICATIONS_GET_SUCCESS,
    PRODUCT_SPECIFICATIONS_GET_REQUEST,
} from '../actionTypes/ProductSpecificationsActionTypes';

function* productSpecificationsSaga(action) {
    try {
        const deviceSize = yield select(selectSizeBasedOnDeviceType);
        const specPayload = {
            payload: {
                url: action.payload,
                deviceSize,
            },
        };
        const apiRes = yield call(FactorySaga, getSpecificationsByUrl, specPayload);
        if (apiRes.isSuccess) {
            const specifications = get(apiRes, 'response.data', []);
            yield all([
                put({
                    type: PRODUCT_SPECIFICATIONS_GET_SUCCESS,
                    payload: { specifications },
                }),
            ]);
        } else {
            const specifications = get(apiRes, 'response.error.message', '');
            yield all([
                put({
                    type: PRODUCT_SPECIFICATIONS_GET_ERROR,
                    payload: { specifications },
                }),
            ]);
        }
    } catch (error) {
        yield put({ type: PRODUCT_SPECIFICATIONS_GET_ERROR, error });
    }
}

const watchProductSpecificationsRequest = function* watchProductSpecificationsRequest() {
    yield takeEvery(PRODUCT_SPECIFICATIONS_GET_REQUEST, productSpecificationsSaga);
};

watchProductSpecificationsRequest.sagaName = 'productSpecificationsRequest';

export default watchProductSpecificationsRequest;
